const MarketingConsentEnum = Object.freeze({
    // HARDNO: 'HARDNO',
    SOFTNO: 'SOFTNO',
    SOFTYES: 'SOFTYES'
    // HARDYES: 'HARDYES'
});

export default MarketingConsentEnum;
